import { appointmentTypeEnumList } from '../../../components/AgGrid/enumLists'

const appointmentTypeValueGetter = (props) => {
  const { value } = props
  return appointmentTypeEnumList(value)
}

export default appointmentTypeValueGetter
